// CertRow.jsx 🧠🧪 CERT Table Row + Collapse Rework (IoC style)
import React from "react";
import CertRowDetails from "./CertRowDetails";
import axios from "axios";

const getBarColor = (score) => {
  if (score >= 9) return "#dc3545"; // red
  if (score >= 7) return "#fd7e14"; // orange
  if (score >= 4) return "#ffc107"; // yellow
  return "#198754"; // green
};

const formatBool = (val) => (Number(val) === 1 ? "Yes" : "No");

const CertRow = ({ cert, isExpanded, toggleCollapse, onEdit, onDelete, onRefresh, showToast, country, userTags = [] }) => {
  const {
    id,
    date,
    alerte,
    vulnerabilites,
    score_cvss,
    faille_exploitee,
    correctif,
    contournement,
  } = cert;
  
  const handleResolve = async (id) => {
	  try {
		const res = await axios.post("/api/resolve_cert.php", { id });
		if (res.data.status === "success") {
		  showToast("Alert marked as resolved", "success");
		  onRefresh(); // refresh data in table
		} else {
		  showToast(res.data.message || "Resolve failed", "danger");
		}
	  } catch (err) {
		console.error("Resolve error:", err);
		showToast("Server error during resolve", "danger");
	  }
	};

  const isToday = date === new Date().toISOString().split("T")[0];
  
  const matchedTags = [];

	userTags.forEach(tag => {
	  if (
		cert.vulnerabilites?.toLowerCase().includes(tag.toLowerCase()) ||
		cert.vendor?.toLowerCase().includes(tag.toLowerCase()) ||
		cert.affected_products?.some(p => p.toLowerCase().includes(tag.toLowerCase()))
	  ) {
		matchedTags.push(tag);
	  }
	});

	const hasTagMatch = matchedTags.length > 0;

  return (
    <>
      {/* 🔹 Ligne principale */}
      <tr
        onClick={toggleCollapse}
        style={{
          cursor: "pointer",
          backgroundColor: isToday ? "#323232" : "#282727",
        }}
      >
        {/* 📅 Date */}
        <td style={{
			backgroundColor: isToday ? "#323232" : "#282727",
			color: isToday ? "#f8f9fa" : undefined,
			verticalAlign: "middle",
			maxWidth: "200px",
			minWidth: "200px",
			padding: "10px"
		}}>
          {date}
        </td>

        {/* 🧨 Alerte */}
        <td
          style={{
            verticalAlign: "middle",
            backgroundColor: Number(alerte) === 1 ? "#925a2a" : "#282727",
            maxWidth: "110px",
            minWidth: "110px",
            color: "#f8f9fa",
			padding: "10px"
          }}
        >
          {formatBool(alerte)}
        </td>

        {/* 🛡️ Vuln */}
		<td
		  style={{
			position: "relative", // ⬅️ AJOUTÉ !!!
			verticalAlign: "middle",
			color: "#c77a3a",
			fontWeight: "bold",
			backgroundColor: "#282727",
			maxWidth: "550px",
			minWidth: "550px",
			overflow: "hidden",
			textOverflow: "ellipsis",
			whiteSpace: "nowrap",
			padding: "10px"
		  }}
		>
		  {/* 🛫 Cockpit ID Icon (FR only) */}
		  {((country.toLowerCase() === "fr" && cert.guid && cert.resolved_for?.toLowerCase() !== "fr") ||
			(country.toLowerCase() !== "fr" && cert.is_bookmarked && cert.resolved_for?.toLowerCase() !== country.toLowerCase())) && (
		  <i
			className="bi bi-hourglass-split me-1"
			style={{ color: "rgb(255, 235, 59)", marginRight: "5px" }}
			data-bs-toggle="tooltip"
			data-bs-placement="top"
			title={
			  country.toLowerCase() === "fr"
				? `Cockpit ID: ${cert.guid}`
				: cert.acknowledged_by
				  ? `Acknowledged by: ${cert.acknowledged_by}`
				  : "Acknowledged"
			}
		  />
		)}
		{/* 🎯 Tag Match Icon */}
		  {hasTagMatch && (
			<i
			  className="bi bi-tags-fill"
			  style={{ color: "#b3947a", marginRight: "5px" }}
			  data-bs-toggle="tooltip"
			  title={`Tags detected: ${matchedTags.join(", ")}`}
			></i>
		  )}
		  {vulnerabilites}

		  {/* ✅ Show check if resolved for user country */}
			{cert.resolved_for && (
			  <span
				style={{
				  position: "absolute",
				  right: "10px",
				  top: "50%",
				  transform: "translateY(-50%)",
				}}
				data-bs-toggle="tooltip"
				data-bs-placement="top"
				title={
				  cert.resolved_for.toLowerCase() === country.toLowerCase()
					? country.toLowerCase() === "fr" && cert.guid
					  ? `Cockpit ID: ${cert.guid}`
					  : `Resolved for ${country.toUpperCase()}`
					: `Resolved for ${cert.resolved_for.toUpperCase()}`
				}
			  >
				<i className="bi bi-patch-check-fill me-1" style={{ color: "#4caf50" }}></i>
			  </span>
			)}
		</td>

        {/* 📊 CVSS */}
        <td style={{ verticalAlign: "middle", backgroundColor: "#282727", maxWidth: "110px", minWidth: "110px", padding: "10px" }}>
          <div
            style={{
              width: "80%",
              backgroundColor: "#f4f4f4",
              borderRadius: "5px",
              height: "10px",
              margin: "0 auto",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: `${score_cvss * 10}%`,
                backgroundColor: getBarColor(score_cvss),
                height: "100%",
                borderRadius: "5px 0 0 5px",
              }}
            />
          </div>
        </td>

        {/* 💥 Exploité */}
        <td
          style={{
            verticalAlign: "middle",
            backgroundColor: Number(faille_exploitee) === 1 ? "#925a2a" : "#282727",
            maxWidth: "110px",
            minWidth: "110px",
            color: "#f8f9fa",
			padding: "10px"
          }}
        >
          {formatBool(faille_exploitee)}
        </td>

        {/* 🛠️ Correctif */}
        <td
          style={{
            verticalAlign: "middle",
            backgroundColor: "#282727",
            maxWidth: "110px",
            minWidth: "110px",
            color: "#f8f9fa",
			padding: "10px"
          }}
        >
          {formatBool(correctif)}
        </td>

        {/* 🌀 Contournement */}
        <td
          style={{
            verticalAlign: "middle",
            backgroundColor: "#282727",
            maxWidth: "110px",
            minWidth: "110px",
            color: "#f8f9fa",
			padding: "10px"
          }}
        >
          {formatBool(contournement)}
        </td>
      </tr>

      {/* 🔻 Details (Collapsable) */}
      <CertRowDetails
        cert={cert}
        isExpanded={isExpanded}
        onEdit={onEdit}
        onDelete={onDelete}
		onRefresh={() => onRefresh(cert.id)}
		showToast={showToast}
		handleResolve={handleResolve}
		country={country}
      />
    </>
  );
};

export default CertRow;
